module.exports = __webpack_public_path__ + "img/mein_schwein_white@2x.369af3fd.png";